import { tzAxios } from 'api/axios';
import { CheckoutRequest } from 'api/requestTypes';
import { CheckoutResponse } from 'api/responseTypes';

export const postCheckout = async (payload: CheckoutRequest) =>
  (await tzAxios.post<CheckoutResponse>(`/ticket-zone/checkout/`, payload)).data;
